import { defineComponent as _defineComponent } from 'vue'
import AdminNavigation from "../../AdminNavigationContainer.vue";
import TechnicalService from "@/services/TechnicalMaintenanceService.ts";
import ResponseData from "@/types/ResponseData";
import { ref, reactive, onMounted, onBeforeUnmount, nextTick, onUpdated } from "vue";
import { useI18n } from "vue3-i18n";
import Alert from "@/components/scan/parts/Alert.vue";
import Loading from "@/components/home/Loading.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const alertMessage = ref("null");
const alertState = ref("neutral");
const i18n = useI18n();
const title = ref("Technical Document Maintenance");
const radioCheck = ref("Service Maintenance");
const modifyRowIndex = ref(0);

// Service Update Variables
const lstService = reactive([]);

// Category Add Variablies
const lstCategory = reactive([]);
const lstCategoryMenu = reactive([]);
const addCategoryDescription = ref("");
const addCategoryFileName = ref("");
const addCategoryUpdFile = ref(null);
const addCategoryMenu = ref("");
const addCategoryShowFlg = ref(false);

const boolAddC_DescriptionError = ref(false);
const boolAddC_MenuError = ref(false);
const boolAddC_FileNameError = ref(false);

const lstEditCategoryUpdFile = reactive([]);

// Document Add Variables
const lstDocument = reactive([]);
const lstUniqueCategory = reactive([]);
const lstUniqueAllCategory = reactive([]);
const addDocumentName = ref("");
const addDocumentCategory = ref("");
const addDocumentShowFlg = ref(false);
const addDocumentFileName = ref("");
const addDocumentUpdFile = ref(null);
const addDocumentCategoryMenu = ref("");

const boolAddD_NameError = ref(false);
const boolAddD_CategoryError = ref(false);
const boolAddD_FileNameError = ref(false);

const lstEditDocumentUpdFile = reactive([]);

onMounted(async function () {
    await Promise.all([
        getTechnicalMenuList(),
        getServiceSpecificationList()
    ]);
    await nextTick();
    handleResize();
    window.addEventListener('resize', onResize);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', onResize);
});

async function onResize() {
  // Wait for DOM updates after resize event before measuring
  handleResize();
  await nextTick();
  handleResize();
}

function handleResize() {
    try {
        var tableHeight = 0;
        var dataHeight = 0;
        var headerTableWidth = 0;
        if (radioCheck.value == 'Service Maintenance') {
            dataHeight = document.getElementById("tblEditServiceSpecificationDetail")?.clientHeight;
            if (dataHeight != 0) {
                tableHeight = document.getElementById("divEditServiceSpecificationDetail")?.clientHeight;
                if (dataHeight > tableHeight) {
                    document.getElementById("divEditHeaderServiceSpecificationDetail").style.width = "calc(100% - 16px)";
                    headerTableWidth = document.getElementById("divEditHeaderServiceSpecificationDetail").getBoundingClientRect().width;
                    if (headerTableWidth < 844) {
                        document.getElementById("divEditHeaderServiceSpecificationDetail").style.width = "844px";
                        document.getElementById("divEditServiceSpecificationDetail").style.width = "860px";
                    } else {
                        document.getElementById("divEditServiceSpecificationDetail").style.width = "100%";
                    }
                } else {
                    document.getElementById("divEditHeaderServiceSpecificationDetail").style.width = "100%";
                    document.getElementById("divEditServiceSpecificationDetail").style.width = "100%";
                }
            }
        } else if (radioCheck.value == 'Category Maintenance') {
            dataHeight = document.getElementById("tblEditCategoryDetail")?.clientHeight;
            if (dataHeight != 0) {
                tableHeight = document.getElementById("divEditCategoryDetail")?.clientHeight;
                if (dataHeight > tableHeight) {
                    document.getElementById("divEditHeaderCategoryDetail").style.width = "calc(100% - 16px)";
                    headerTableWidth = document.getElementById("divEditHeaderCategoryDetail").getBoundingClientRect().width;
                    if (headerTableWidth < 844) {
                        document.getElementById("divEditHeaderCategoryDetail").style.width = "844px";
                        document.getElementById("divEditCategoryDetail").style.width = "860px";
                    } else {
                        document.getElementById("divEditCategoryDetail").style.width = "100%";
                    }
                } else {
                    document.getElementById("divEditHeaderCategoryDetail").style.width = "100%";
                    document.getElementById("divEditCategoryDetail").style.width = "100%";
                }
            }
        } else if (radioCheck.value == 'Document Maintenance') {
            dataHeight = document.getElementById("tblEditDocumentDetail")?.clientHeight;
            if (dataHeight != 0) {
                tableHeight = document.getElementById("divEditDocumentDetail")?.clientHeight;
                if (dataHeight > tableHeight) {
                    document.getElementById("divEditHeaderDocumentDetail").style.width = "calc(100% - 16px)";
                    headerTableWidth = document.getElementById("divEditHeaderDocumentDetail").getBoundingClientRect().width;
                    if (headerTableWidth < 844) {
                        document.getElementById("divEditHeaderDocumentDetail").style.width = "844px";
                        document.getElementById("divEditDocumentDetail").style.width = "860px";
                    } else {
                        document.getElementById("divEditDocumentDetail").style.width = "100%";
                    }
                } else {
                    document.getElementById("divEditHeaderDocumentDetail").style.width = "100%";
                    document.getElementById("divEditDocumentDetail").style.width = "100%";
                }
            }
        }
    } catch (e) {
        isLoading.value = false;
    }
}

// 技術文書の管理タイプ変更
const rdoCheckChange = (event: { target: { value: any; }; }) => {
    radioCheck.value = event.target.value;
    alertMessage.value = "null";
    alertState.value = "neutral";
    if (radioCheck.value == 'Service Maintenance') {
        if (lstCategory.length == 0) {
            getServiceSpecificationList();
        }
    } else if (radioCheck.value == 'Category Maintenance') {
        if (lstCategory.length == 0) {
            getCategoryDetail();
        }
    } else {
        if (lstDocument.length == 0) {
            getDocumentDetail();
        }
    }
}

// 技術文書のサービス管理(Start)
// Admin Menu以外のサービスによって文書リスト取得
const getServiceSpecificationList = () => {
    isLoading.value = true;
    lstService.splice(0);
    TechnicalService.getServiceSpecificationList()
        .then((response: ResponseData) => {
            if (response.data != null) {
                lstService.push(response.data.specificationList);
            }
            isLoading.value = false;
        })
        .catch((resError: ResponseData) => {
            if (resError.response.data.dbException != undefined) {
                const firstError = resError.response.data.dbException[0];
                alertMessage.value = i18n.t("err093") + i18n.t("err080").replace("errorMessageValue", firstError.message);
            } else {
                alertMessage.value = i18n.t("err093") + i18n.t("err080").replace("errorMessageValue", resError.response.data.error);
            }
            alertState.value = "error";
            isLoading.value = false;
        });
}

// サービスの文書をクリアと登録更新
const updateOrClearSpecification = (processName: string, rowIndex = -1) => {
    alertMessage.value = "null";
    alertState.value = "neutral";
    if(lstService.length != 0){
        if(processName == "Update") {
            isLoading.value = true;
            var data = {
                mainMenuCode : lstService[0][rowIndex].mainMenuCode,
                specification : lstService[0][rowIndex].specification
            }
            TechnicalService.insertOrUpdateSpecification(data)
            .then((_) => {
                alertMessage.value = i18n.t("suc042");
                alertState.value = "success";
                isLoading.value = false;
            })
            .catch((resError: ResponseData) => {
                if (resError.response.data.dbException != undefined) {
                    const firstError = resError.response.data.dbException[0];
                    alertMessage.value = i18n.t("err094") + i18n.t("err080").replace("errorMessageValue", firstError.message);
                } else {
                    alertMessage.value = i18n.t("err094") + i18n.t("err080").replace("errorMessageValue", resError.response.data.error);
                }
                alertState.value = "error";
                isLoading.value = false;
            });
            isLoading.value = false;
        } else if (processName == "Clear") {
            lstService[0][rowIndex].specification = "";
        }
    }
}
// 技術文書のサービス管理(End)

// 技術文書のカテゴリー管理(Start)
const getTechnicalMenuList = () => {
    lstCategoryMenu.splice(0);
    TechnicalService.getTechnicalMenuList()
        .then((response: ResponseData) => {
            if (response.data != null) {
                lstCategoryMenu.push(response.data.technicalMenuList);
            }
            isLoading.value = false;
        })
        .catch((resError: ResponseData) => {
            if (resError.response.data.dbException != undefined) {
                const firstError = resError.response.data.dbException[0];
                alertMessage.value = i18n.t("err084") + i18n.t("err080").replace("errorMessageValue", firstError.message);
            } else {
                alertMessage.value = i18n.t("err084") + i18n.t("err080").replace("errorMessageValue", resError.response.data.error);
            }
            alertState.value = "error";
            isLoading.value = false;
        });
}

const getCategoryDetail = () => {
    isLoading.value = true;
    lstCategory.splice(0);
    var data = {
        selectedTechType: 0,
        mainMenuCode: ""
    }
    TechnicalService.getTechnicalDocumentList(data)
        .then((response: ResponseData) => {
            if (response.data != null) {
                lstCategory.push(response.data.technicalList);
            }
            isLoading.value = false;
        })
        .catch((resError: ResponseData) => {
            if (resError.response.data.dbException != undefined) {
                const firstError = resError.response.data.dbException[0];
                alertMessage.value = i18n.t("err082") + i18n.t("err080").replace("errorMessageValue", firstError.message);
            } else {
                alertMessage.value = i18n.t("err082") + i18n.t("err080").replace("errorMessageValue", resError.response.data.error);
            }
            alertState.value = "error";
            isLoading.value = false;
        });
}

const categoryMenuChange = (event: { target: { value: any; }; }, rowIndex: string | number) => {
    lstCategory[0][rowIndex].mainMenuCode_id = event.target.value;
}

const addOrUpdateTechnicalCategory = (processName: string, rowIndex = -1) => {
    isLoading.value = true;
    alertMessage.value = "null";
    alertState.value = "neutral";
    var data = {
        description: addCategoryDescription.value,
        fileName: addCategoryFileName.value,
        uploadFile: addCategoryUpdFile.value,
        isShowing: addCategoryShowFlg.value,
        mainMenuCode: addCategoryMenu.value
    }
    if (processName == "Add") {
        if (categoryAddInputCheck(data)) {
            addTechnicalCategory();
        } else {
            isLoading.value = false;
        }
    } else if (processName == "Update") {
        if (categoryEditInputCheck(lstCategory[0][rowIndex], rowIndex)) {
            updateTechnicalCategory(rowIndex);
        } else {
            isLoading.value = false;
        }
    } else if (processName == "Delete") {
        if (confirm(i18n.t("cnf010"))) {
            deleteTechnicalCategory(rowIndex);
        } else {
            isLoading.value = false;
        }
    }
}

const addTechnicalCategory = () => {
    var formData = new FormData();
    formData.append("description", addCategoryDescription.value);
    formData.append("fileName", addCategoryFileName.value);
    formData.append("isShowing", addCategoryShowFlg.value);
    formData.append("mainMenuCode", addCategoryMenu.value);
    TechnicalService.insertTechnicalCategory(formData)
        .then((response: ResponseData) => {
            if (response.data != null && lstCategory.length != 0) {
                lstCategory[0].push(response.data.technicalCategory);
                lstCategory[0].sort(function (x: { categoryId: number; }, y: { categoryId: number; }) {
                    return x.categoryId - y.categoryId;
                });

                lstUniqueAllCategory.push({
                    categoryId: response.data.technicalCategory.categoryId,
                    description: response.data.technicalCategory.description,
                    mainMenuCode: response.data.technicalCategory.mainMenuCode_id
                });
                lstUniqueAllCategory.sort(function (x: { categoryId: number; }, y: { categoryId: number; }) {
                    return x.categoryId - y.categoryId;
                });
                alertMessage.value = i18n.t("suc039");
                alertState.value = "success";
                resetErrorStatus("addCategory");
            }
            isLoading.value = false;
            if (addCategoryUpdFile.value != null) {
                formData = new FormData();
                formData.append("categoryId", response.data.technicalCategory.categoryId);
                formData.append("categoryAddedFile", addCategoryUpdFile.value);
                TechnicalService.manageBucketFile(formData)
                    .catch((resError: ResponseData) => {
                        alertMessage.value = i18n.t("err091") + i18n.t("err080").replace("errorMessageValue", resError.response.data.error);
                        alertState.value = "error";
                        isLoading.value = true;
                    });
            }
            clearAddInputData("addCategory");
        })
        .catch((resError: ResponseData) => {
            if (resError.response.data.dbException != undefined) {
                const firstError = resError.response.data.dbException[0];
                alertMessage.value = i18n.t("err085") + i18n.t("err080").replace("errorMessageValue", firstError.message);
            } else {
                alertMessage.value = i18n.t("err085") + i18n.t("err080").replace("errorMessageValue", resError.response.data.error);
            }
            alertState.value = "error";
            isLoading.value = false;
        });
}

const updateTechnicalCategory = (rowIndex: number) => {
    var targetRow = lstCategory[0][rowIndex];
    var formData = new FormData();
    formData.append("categoryId", targetRow.categoryId);
    formData.append("description", targetRow.description);
    formData.append("fileName", targetRow.fileName);
    formData.append("isShowing", targetRow.isShowing);
    formData.append("mainMenuCode", targetRow.mainMenuCode_id);
    TechnicalService.updateTechnicalCategory(formData)
        .then((response: ResponseData) => {
            if (lstCategory.length != 0) {
                resetErrorStatus("editCategory", rowIndex);
            }

            var updatedRow = lstUniqueAllCategory.filter((x: { categoryId: any; }) => x.categoryId == targetRow.categoryId)
            if (updatedRow.length != 0) {
                updatedRow[0].description = targetRow.description;
            }
            alertMessage.value = i18n.t("suc006");
            alertState.value = "success";
            isLoading.value = false;
            var existedFile = lstEditCategoryUpdFile.filter((obj: { categoryId: any; }) => obj.categoryId == targetRow.categoryId)
            if (existedFile.length != 0) {
                formData = new FormData();
                formData.append("categoryId", targetRow.categoryId);
                formData.append("oldFileName", response.data.oldFileName)
                formData.append("categoryUpdateFile", existedFile[0].editCategoryUpdFile);
                TechnicalService.manageBucketFile(formData)
                    .catch((resError: ResponseData) => {
                        alertMessage.value = i18n.t("err091") + i18n.t("err080").replace("errorMessageValue", resError.response.data.error);
                        alertState.value = "error";
                        isLoading.value = true;
                    });
            }
        })
        .catch((resError: ResponseData) => {
            if (resError.response.data.dbException != undefined) {
                const firstError = resError.response.data.dbException[0];
                alertMessage.value = i18n.t("err086") + i18n.t("err080").replace("errorMessageValue", firstError.message);
            } else {
                alertMessage.value = i18n.t("err086") + i18n.t("err080").replace("errorMessageValue", resError.response.data.error);
            }
            alertState.value = "error";
            isLoading.value = false;
        });
}

const deleteTechnicalCategory = (rowIndex: number) => {
    var data = {
        categoryId: lstCategory[0][rowIndex].categoryId,
        fileName: lstCategory[0][rowIndex].fileName
    }
    TechnicalService.deleteTechnicalCategory(data)
        .then(() => {
            if (lstCategory.length != 0) {
                const indexVal = lstCategory[0].findIndex((obj: any) => { return obj.categoryId === data.categoryId; });
                if (indexVal != -1) {
                    lstCategory[0].splice(indexVal, 1);
                }
                const indexVal2 = lstUniqueAllCategory.findIndex((x: { categoryId: any; }) => { return x.categoryId == data.categoryId; });
                if (indexVal2 != -1) {
                    lstUniqueAllCategory.splice(indexVal2, 1);
                }
                alertMessage.value = i18n.t("suc040");
                alertState.value = "success";
                resetErrorStatus("deleteCategory", rowIndex);
            }
            isLoading.value = false;
        })
        .catch((resError: ResponseData) => {
            if (resError.response.data.dbException != undefined) {
                const firstError = resError.response.data.dbException[0];
                alertMessage.value = i18n.t("err087") + i18n.t("err080").replace("errorMessageValue", firstError.message);
            } else {
                alertMessage.value = i18n.t("err087") + i18n.t("err080").replace("errorMessageValue", resError.response.data.error);
            }
            alertState.value = "error";
            isLoading.value = false;
        });
}

const categoryAddInputCheck = (data: { description: any; fileName?: any; mainMenuCode?: any; }) => {
    var chkResult = true;
    resetErrorStatus("addCategory");
    var re = /[`!@#$%^&*()_+\-={};':"\\|,.<>/?＿~]/;
    if (data.description.trim() == "") {
        chkResult = false;
        alert(i18n.t("alt091"));
        boolAddC_DescriptionError.value = true;
    } else if (re.test(data.description)) {
        chkResult = false;
        alert(i18n.t("alt094"));
        boolAddC_DescriptionError.value = true;
    }
    if (data.mainMenuCode.trim() == "") {
        chkResult = false;
        alert(i18n.t("alt092"));
        boolAddC_MenuError.value = true;
    }
    return chkResult;
}

const categoryEditInputCheck = (_data: { categoryId: any; description: any; fileName?: any; mainMenuCode?: any; }, rowIndex: number) => {
    var chkResult = true;
    resetErrorStatus("editCategory", rowIndex);

    var txtC_Description = document.getElementById("txtC_Description" + rowIndex) as HTMLInputElement;
    var re = /[`!@#$%^&*()_+\-={};':"\\|,.<>/?＿~]/;
    lstCategory[0][rowIndex].description = txtC_Description?.value;
    if (txtC_Description?.value == "") {
        chkResult = false;
        alert(i18n.t("alt091"));
        txtC_Description?.classList.add('techErrorBox');
    } else if (re.test(txtC_Description?.value)) {
        chkResult = false;
        alert(i18n.t("alt094"));
        txtC_Description?.classList.add('techErrorBox');
    }
    return chkResult;
}

const resetErrorStatus = (processName = "", rowIndex = -1) => {
    if (processName == "addCategory") {
        errResetAddedCategory();
    } else if (processName == "editCategory") {
        var txtC_Description = document.getElementById("txtC_Description" + rowIndex);
        var txtUpdC_file = document.getElementById("txtUpdC_file" + rowIndex);
        txtC_Description?.classList.remove('techErrorBox');
        txtUpdC_file?.classList.remove('techErrorBox');
    } else if (processName == "addDocument") {
        errResetAddedDocument();
    } else if (processName == "editDocument") {
        var txtUpdD_file = document.getElementById("txtUpdD_file" + rowIndex);
        var txtD_Name = document.getElementById("txtD_Name" + rowIndex);
        var ddlD_Category = document.getElementById("ddlD_Category" + rowIndex);
        txtUpdD_file?.classList.remove('techErrorBox');
        txtD_Name?.classList.remove('techErrorBox');
        ddlD_Category?.classList.remove('techErrorBox');
    } else if (processName == "deleteCategory" && lstCategory.length != 0) {
        errResetDeletedCategory(rowIndex);
    } else if (processName == "deleteDocument" && lstDocument.length != 0) {
        errResetDeletedDocument(rowIndex);
    }
}

const errResetAddedCategory = () => {
    boolAddC_DescriptionError.value = boolAddC_MenuError.value = boolAddC_FileNameError.value = false;
    var lenCategory = lstCategory[0].length;
    var txtC_Description = null;
    var re = /[`!@#$%^&*()_+\-={};':"\\|,.<>/?＿~]/;
    for (let cIdx = 0; cIdx < lenCategory; cIdx++) {
        txtC_Description = document.getElementById("txtC_Description" + cIdx) as HTMLInputElement;
        if (txtC_Description != undefined) {
            if (!re.test(txtC_Description.value) && txtC_Description.classList.contains("techErrorBox")) {
                txtC_Description.classList.remove("techErrorBox");
            } else if (re.test(txtC_Description.value) && !txtC_Description.classList.contains("techErrorBox")) {
                txtC_Description.classList.add("techErrorBox");
            }
        }
    }
}

const errResetAddedDocument = () => {
    boolAddD_NameError.value = boolAddD_CategoryError.value = boolAddD_FileNameError.value = false;
    var lenDocument = lstDocument[0].length;
    var txtUpdD_file = null;
    var txtD_Name = null;
    var ddlD_Category = null;
    var re = /[`!@#$%^&*()_+\-={};':"\\|,.<>/?＿~]/;
    for (let cIdx = 0; cIdx < lenDocument; cIdx++) {
        txtUpdD_file = document.getElementById("txtUpdD_file" + cIdx) as HTMLInputElement;
        txtD_Name = document.getElementById("txtD_Name" + cIdx) as HTMLInputElement;
        ddlD_Category = document.getElementById("ddlD_Category" + cIdx) as HTMLInputElement;
        if (txtUpdD_file != undefined && txtD_Name != undefined && ddlD_Category != undefined) {
            if (txtUpdD_file.value != "" && txtUpdD_file.classList.contains("techErrorBox")) {
                txtUpdD_file.classList.remove("techErrorBox");
            } else if (txtUpdD_file.value == "" && !txtUpdD_file.classList.contains("techErrorBox")) {
                txtUpdD_file.classList.add("techErrorBox");
            }
            if (!re.test(txtD_Name.value) && txtD_Name.classList.contains("techErrorBox")) {
                txtD_Name.classList.remove("techErrorBox");
            } else if (re.test(txtD_Name.value) && !txtD_Name.classList.contains("techErrorBox")) {
                txtD_Name.classList.add("techErrorBox");
            }
            if (ddlD_Category.value != "" && ddlD_Category.classList.contains("techErrorBox")) {
                ddlD_Category.classList.remove("techErrorBox");
            } else if (ddlD_Category.value == "" && !ddlD_Category.classList.contains("techErrorBox")) {
                ddlD_Category.classList.add("techErrorBox");
            }
        }
    }
}

const errResetDeletedCategory = (rowIndex: number) => {
    var txtC_DescriptionNext = null;
    var txtC_DescriptionBack = null;
    var lenCategory = lstCategory[0].length;
    if (lenCategory == rowIndex + 1) {
        txtC_DescriptionNext = document.getElementById("txtC_Description" + (rowIndex + 1));
        if (txtC_DescriptionNext?.classList.contains('techErrorBox')) {
            txtC_DescriptionBack = document.getElementById("txtC_Description" + rowIndex);
            txtC_DescriptionBack?.classList.add('techErrorBox');
            txtC_DescriptionNext?.classList.remove('techErrorBox');
        }
    } else {
        for (let cIdx = rowIndex; cIdx < lenCategory; cIdx++) {
            if ((cIdx + 1) < lenCategory) {
                txtC_DescriptionNext = document.getElementById("txtC_Description" + (cIdx + 1));
                if (txtC_DescriptionNext?.classList.contains('techErrorBox')) {
                    txtC_DescriptionBack = document.getElementById("txtC_Description" + cIdx);
                    txtC_DescriptionBack?.classList.add('techErrorBox');
                    txtC_DescriptionNext?.classList.remove('techErrorBox');
                }
            }
        }
    }
}

const errResetDeletedDocument = (rowIndex: number) => {
    var txtUpdD_fileNext = null;
    var txtUpdD_fileBack = null;
    var txtD_NameNext = null;
    var txtD_NameBack = null;
    var ddlD_CategoryNext = null;
    var ddlD_CategoryBack = null;
    var lenDocument = lstDocument[0].length;
    if (lenDocument == rowIndex + 1) {
        txtUpdD_fileNext = document.getElementById("txtUpdD_file" + (rowIndex + 1));
        if (txtUpdD_fileNext?.classList.contains('techErrorBox')) {
            txtUpdD_fileBack = document.getElementById("txtUpdD_file" + rowIndex);
            txtUpdD_fileBack?.classList.add('techErrorBox');
            txtUpdD_fileNext?.classList.remove('techErrorBox');
        }
        txtD_NameNext = document.getElementById("txtD_Name" + (rowIndex + 1));
        if (txtD_NameNext?.classList.contains('techErrorBox')) {
            txtD_NameBack = document.getElementById("txtD_Name" + rowIndex);
            txtD_NameBack?.classList.add('techErrorBox');
            txtD_NameNext?.classList.remove('techErrorBox');
        }
        ddlD_CategoryNext = document.getElementById("ddlD_Category" + (rowIndex + 1));
        if (ddlD_CategoryNext?.classList.contains('techErrorBox')) {
            ddlD_CategoryBack = document.getElementById("ddlD_Category" + rowIndex);
            ddlD_CategoryBack?.classList.add('techErrorBox');
            ddlD_CategoryNext?.classList.remove('techErrorBox');
        }
    } else {
        for (let dIdx = rowIndex; dIdx < lenDocument; dIdx++) {
            if ((dIdx + 1) < lenDocument) {
                txtUpdD_fileNext = document.getElementById("txtUpdD_file" + (dIdx + 1));
                if (txtUpdD_fileNext?.classList.contains('techErrorBox')) {
                    txtUpdD_fileBack = document.getElementById("txtUpdD_file" + dIdx);
                    txtUpdD_fileBack?.classList.add('techErrorBox');
                    txtUpdD_fileNext?.classList.remove('techErrorBox');
                }
                txtD_NameNext = document.getElementById("txtD_Name" + (dIdx + 1));
                if (txtD_NameNext?.classList.contains('techErrorBox')) {
                    txtD_NameBack = document.getElementById("txtD_Name" + dIdx);
                    txtD_NameBack?.classList.add('techErrorBox');
                    txtD_NameNext?.classList.remove('techErrorBox');
                }
                ddlD_CategoryNext = document.getElementById("ddlD_Category" + (dIdx + 1));
                if (ddlD_CategoryNext?.classList.contains('techErrorBox')) {
                    ddlD_CategoryBack = document.getElementById("ddlD_Category" + dIdx);
                    ddlD_CategoryBack?.classList.add('techErrorBox');
                    ddlD_CategoryNext?.classList.remove('techErrorBox');
                }
            }
        }
    }
}

const clearAddInputData = (processName = "") => {
    if (processName == "addCategory") {
        addCategoryDescription.value = "";
        addCategoryFileName.value = "";
        addCategoryUpdFile.value = null;
        addCategoryMenu.value = "";
        addCategoryShowFlg.value = false;
    } else if (processName == "addDocument") {
        addDocumentFileName.value = "";
        addDocumentUpdFile.value = null;
        addDocumentName.value = "";
        addDocumentCategoryMenu.value = "";
        addDocumentCategory.value = "";
        addDocumentShowFlg.value = false;
    }
}
// 技術文書のカテゴリー管理(End)

// 技術文書のドキュメント管理(Start)
const getDocumentDetail = () => {
    isLoading.value = true;
    lstDocument.splice(0);
    var data = {
        selectedTechType: 1,
        categoryId: ""
    }
    TechnicalService.getTechnicalDocumentList(data)
        .then((response: ResponseData) => {
            if (response.data != null) {
                lstDocument.push(response.data.technicalList);
                lstUniqueAllCategory.splice(0);
                for (let obj of response.data.categoryList) {
                    lstUniqueAllCategory.push({
                        categoryId: obj["categoryId"],
                        description: obj["description"],
                        mainMenuCode: obj["mainMenuCode_id"]
                    })
                }
            }
            isLoading.value = false;
        })
        .catch((resError: ResponseData) => {
            if (resError.response.data.dbException != undefined) {
                const firstError = resError.response.data.dbException[0];
                alertMessage.value = i18n.t("err083") + i18n.t("err080").replace("errorMessageValue", firstError.message);
            } else {
                alertMessage.value = i18n.t("err083") + i18n.t("err080").replace("errorMessageValue", resError.response.data.error);
            }
            alertState.value = "error";
            isLoading.value = false;
        });
}

const getCategoryByMenu = (event: { target: { value: any; }; }, rowIndex = -1) => {
    lstUniqueCategory.splice(0);
    if (lstCategory.length != 0) {
        if (rowIndex == -1) {
            var lstCategoryByMenu = lstCategory[0].filter((obj: { mainMenuCode_id: any; }) => obj.mainMenuCode_id == addDocumentCategoryMenu.value)
            for (let i = 0; i < lstCategoryByMenu.length; i++) {
                lstUniqueCategory.push({
                    categoryId: lstCategoryByMenu[i].categoryId,
                    description: lstCategoryByMenu[i].description,
                    mainMenuCode: lstCategoryByMenu[i].mainMenuCode_id
                })
            }
        } else {
            lstDocument[0][rowIndex].mainMenuCode_id = event.target.value;
        }
    }
}

const addOrUpdateTechnicalDocument = (processName: string, rowIndex = -1) => {
    isLoading.value = true;
    alertMessage.value = "null";
    alertState.value = "neutral";
    var data = {
        fileName: addDocumentFileName.value,
        documentName: addDocumentName.value,
        documentCategory: addDocumentCategory.value,
        isShowing: addDocumentShowFlg.value
    }
    if (processName == "Add") {
        if (documentAddInputCheck(data)) {
            addTechnicalDocument();
        } else {
            isLoading.value = false;
        }
    } else if (processName == "Update") {
        if (documentEditInputCheck(rowIndex)) {
            updateTechnicalDocument(rowIndex);
        } else {
            isLoading.value = false;
        }
    } else if (processName == "Delete") {
        if (confirm(i18n.t("cnf011"))) {
            deleteTechnicalDocument(rowIndex);
        } else {
            isLoading.value = false;
        }
    }
}

const addTechnicalDocument = () => {
    var formData = new FormData();
    formData.append("documentName", addDocumentName.value);
    formData.append("fileName", addDocumentFileName.value);
    formData.append("isShowing", addDocumentShowFlg.value);
    formData.append("categoryId", addDocumentCategory.value);
    formData.append("mainMenuCode", addDocumentCategoryMenu.value);
    TechnicalService.insertTechnicalDocument(formData)
        .then((response: ResponseData) => {
            if (response.data != null && lstDocument.length != 0) {
                lstDocument[0].push(response.data.technicalDocument);
                lstDocument[0].sort(function (x: { documentName: string; }, y: { documentName: string; }) {
                    return x.documentName.localeCompare(y.documentName);
                });
                alertMessage.value = i18n.t("suc039");
                alertState.value = "success";
                resetErrorStatus("addDocument");
            }
            isLoading.value = false;
            if (addDocumentUpdFile.value != null) {
                formData = new FormData();
                formData.append("id", response.data.technicalDocument.id);
                formData.append("documentAddedFile", addDocumentUpdFile.value);
                TechnicalService.manageBucketFile(formData)
                    .catch((resError: ResponseData) => {
                        alertMessage.value = i18n.t("err092") + i18n.t("err080").replace("errorMessageValue", resError.response.data.error);
                        alertState.value = "error";
                        isLoading.value = true;
                    });
            }
            clearAddInputData("addDocument");
        })
        .catch((resError: ResponseData) => {
            if (resError.response.data.dbException != undefined) {
                const firstError = resError.response.data.dbException[0];
                alertMessage.value = i18n.t("err088") + i18n.t("err080").replace("errorMessageValue", firstError.message);
            } else {
                alertMessage.value = i18n.t("err088") + i18n.t("err080").replace("errorMessageValue", resError.response.data.error);
            }
            alertState.value = "error";
            isLoading.value = false;
        });
}

const updateTechnicalDocument = (rowIndex: number) => {
    var targetRow = lstDocument[0][rowIndex];
    var formData = new FormData();
    formData.append("id", targetRow.id);
    formData.append("documentName", targetRow.documentName);
    formData.append("fileName", targetRow.fileName);
    formData.append("isShowing", targetRow.isShowing);
    formData.append("categoryId", targetRow.categoryId_id);
    formData.append("mainMenuCode", targetRow.mainMenuCode_id);
    TechnicalService.updateTechnicalDocument(formData)
        .then((response: ResponseData) => {
            if (lstDocument.length != 0) {
                lstDocument[0].sort(function (x: { documentName: string; }, y: { documentName: string; }) {
                    return x.documentName.localeCompare(y.documentName);
                });
                resetErrorStatus("editDocument", rowIndex);
            }
            alertMessage.value = i18n.t("suc006");
            alertState.value = "success";
            isLoading.value = false;
            var existedFile = lstEditDocumentUpdFile.filter((obj: { documentName: any; }) => obj.documentName == targetRow.documentName)
            if (existedFile.length != 0) {
                formData = new FormData();
                formData.append("id", targetRow.id);
                formData.append("oldFileName", response.data.oldFileName)
                formData.append("documentUpdateFile", existedFile[0].editDocumentUpdFile);
                TechnicalService.manageBucketFile(formData)
                    .catch((resError: ResponseData) => {
                        alertMessage.value = i18n.t("err092") + i18n.t("err080").replace("errorMessageValue", resError.response.data.error);
                        alertState.value = "error";
                        isLoading.value = true;
                    });
            }
        })
        .catch((resError: ResponseData) => {
            if (resError.response.data.dbException != undefined) {
                const firstError = resError.response.data.dbException[0];
                alertMessage.value = i18n.t("err089") + i18n.t("err080").replace("errorMessageValue", firstError.message);
            } else {
                alertMessage.value = i18n.t("err089") + i18n.t("err080").replace("errorMessageValue", resError.response.data.error);
            }
            alertState.value = "error";
            isLoading.value = false;
        });
}

const deleteTechnicalDocument = (rowIndex: number) => {
    var data = {
        id: lstDocument[0][rowIndex].id,
        fileName: lstDocument[0][rowIndex].fileName
    }
    TechnicalService.deleteTechnicalDocument(data)
        .then(() => {
            if (lstDocument.length != 0) {
                const indexVal = lstDocument[0].findIndex((obj: any) => { return obj.id === data.id; });
                if (indexVal != -1) {
                    lstDocument[0].splice(indexVal, 1);
                }
                alertMessage.value = i18n.t("suc040");
                alertState.value = "success";
                resetErrorStatus("deleteDocument", rowIndex);
            }
            isLoading.value = false;
        })
        .catch((resError: ResponseData) => {
            if (resError.response.data.dbException != undefined) {
                const firstError = resError.response.data.dbException[0];
                alertMessage.value = i18n.t("err090") + i18n.t("err080").replace("errorMessageValue", firstError.message);
            } else {
                alertMessage.value = i18n.t("err090") + i18n.t("err080").replace("errorMessageValue", resError.response.data.error);
            }
            alertState.value = "error";
            isLoading.value = false;
        });
}

const documentAddInputCheck = (data: { fileName: any; documentName: any; documentCategory: any; isShowing?: any; }) => {
    var chkResult = true;
    resetErrorStatus("addDocument");
    var re = /[`!@#$%^&*()_+\-={};':"\\|,.<>/?＿~]/;
    if (data.fileName == "") {
        chkResult = false;
        alert(i18n.t("alt095"));
        boolAddD_FileNameError.value = true;
    }
    if (data.documentName.trim() == "") {
        chkResult = false;
        alert(i18n.t("alt096"));
        boolAddD_NameError.value = true;
    } else if (re.test(data.documentName)) {
        chkResult = false;
        alert(i18n.t("alt097"));
        boolAddD_NameError.value = true;
    }
    if (data.documentCategory.toString().trim() == "") {
        chkResult = false;
        alert(i18n.t("alt098"));
        boolAddD_CategoryError.value = true;
    }
    return chkResult;
}

const documentEditInputCheck = (rowIndex: number) => {
    var chkResult = true;
    resetErrorStatus("editDocument", rowIndex);

    var txtD_Name = document.getElementById("txtD_Name" + rowIndex) as HTMLInputElement;
    var ddlD_Category = document.getElementById("ddlD_Category" + rowIndex) as HTMLInputElement;
    var re = /[`!@#$%^&*()_+\-={};':"\\|,.<>/?＿~]/;
    lstDocument[0][rowIndex].documentName = txtD_Name?.value;
    if (txtD_Name?.value == "") {
        chkResult = false;
        alert(i18n.t("alt096"));
        txtD_Name?.classList.add('techErrorBox');
    } else if (re.test(txtD_Name?.value)) {
        chkResult = false;
        alert(i18n.t("alt097"));
        txtD_Name?.classList.add('techErrorBox');
    }
    if (ddlD_Category?.value == "") {
        chkResult = false;
        alert(i18n.t("alt098"));
        ddlD_Category?.classList.add('techErrorBox');
    }
    return chkResult;
}
// 技術文書のドキュメント管理(End)

// 技術文書の共通機能(Start)
const uploadClick = (event: { target: { id: any; }; }, rowIndex = 0) => {
    var btnName = event.target.id;
    var btnSelect = null;
    modifyRowIndex.value = rowIndex;
    if (btnName == "btnAddCategory") {
        btnSelect = document.getElementById("updCategory");
    } else if (btnName == "btnRowAddCategory") {
        btnSelect = document.getElementById("updRowAddCategory" + rowIndex);
    } else if (btnName == "btnAddDocument") {
        btnSelect = document.getElementById("updDocument");
    } else if (btnName == "btnRowAddDocument") {
        btnSelect = document.getElementById("updRowAddDocument" + rowIndex);
    }
    btnSelect?.click();
}

const selectFile = (event: { target: { id: any; files: any[]; }; }) => {
    var btnName = event.target.id;
    var file = event.target.files[0];
    var strExtension = file.name.substring(file.name.lastIndexOf("."));
    if (btnName == "updCategory") {
        if (["JPEG", "JPG", "PNG", "GIF", "TIFF", "PSD", "RAW"].includes(strExtension.substring(1).toUpperCase())) {
            addCategoryFileName.value = file.name;
            addCategoryUpdFile.value = file;
            boolAddC_FileNameError.value = false;
        } else {
            alert(i18n.t("alt093"));
            boolAddC_FileNameError.value = true;
        }
    } else if (btnName.startsWith("updRowAddCategory")) {
        var txtUpdC_file = document.getElementById("txtUpdC_file" + modifyRowIndex.value);
        if (["JPEG", "JPG", "PNG", "GIF", "TIFF", "PSD", "RAW"].includes(strExtension.substring(1).toUpperCase())) {
            lstCategory[0][modifyRowIndex.value].fileName = file.name;
            var categoryId = lstCategory[0][modifyRowIndex.value].categoryId;
            var existedFile = lstEditCategoryUpdFile.filter((obj: { categoryId: any; }) => obj.categoryId == categoryId)
            if (existedFile.length == 0) {
                lstEditCategoryUpdFile.push({
                    categoryId: categoryId,
                    editCategoryUpdFile: file
                })
            } else {
                existedFile[0].editCategoryUpdFile = file;
            }
            txtUpdC_file?.classList.remove('techErrorBox');
        } else {
            alert(i18n.t("alt093"));
            txtUpdC_file?.classList.add('techErrorBox');
        }
    } else if (btnName == "updDocument") {
        if (["PDF"].includes(strExtension.substring(1).toUpperCase())) {
            addDocumentFileName.value = file.name;
            addDocumentUpdFile.value = file;
            boolAddD_FileNameError.value = false;
        } else {
            alert(i18n.t("alt080"));
            boolAddD_FileNameError.value = true;
        }
    } else if (btnName.startsWith("updRowAddDocument")) {
        var txtUpdD_file = document.getElementById("txtUpdD_file" + modifyRowIndex.value);
        if (["PDF"].includes(strExtension.substring(1).toUpperCase())) {
            lstDocument[0][modifyRowIndex.value].fileName = file.name;
            var documentName = lstDocument[0][modifyRowIndex.value].documentName;
            var existedFile2 = lstEditDocumentUpdFile.filter((obj: { documentName: any; }) => obj.documentName == documentName)
            if (existedFile2.length == 0) {
                lstEditDocumentUpdFile.push({
                    documentName: documentName,
                    editDocumentUpdFile: file
                })
            } else {
                existedFile2[0].editDocumentUpdFile = file;
            }
            txtUpdD_file?.classList.remove('techErrorBox');
        } else {
            alert(i18n.t("alt080"));
            txtUpdD_file?.classList.add('techErrorBox');
        }
    }
};
// 技術文書の共通機能(End)

onUpdated(function () {
    handleResize();
});

const __returned__ = { isLoading, alertMessage, alertState, i18n, title, radioCheck, modifyRowIndex, lstService, lstCategory, lstCategoryMenu, addCategoryDescription, addCategoryFileName, addCategoryUpdFile, addCategoryMenu, addCategoryShowFlg, boolAddC_DescriptionError, boolAddC_MenuError, boolAddC_FileNameError, lstEditCategoryUpdFile, lstDocument, lstUniqueCategory, lstUniqueAllCategory, addDocumentName, addDocumentCategory, addDocumentShowFlg, addDocumentFileName, addDocumentUpdFile, addDocumentCategoryMenu, boolAddD_NameError, boolAddD_CategoryError, boolAddD_FileNameError, lstEditDocumentUpdFile, onResize, handleResize, rdoCheckChange, getServiceSpecificationList, updateOrClearSpecification, getTechnicalMenuList, getCategoryDetail, categoryMenuChange, addOrUpdateTechnicalCategory, addTechnicalCategory, updateTechnicalCategory, deleteTechnicalCategory, categoryAddInputCheck, categoryEditInputCheck, resetErrorStatus, errResetAddedCategory, errResetAddedDocument, errResetDeletedCategory, errResetDeletedDocument, clearAddInputData, getDocumentDetail, getCategoryByMenu, addOrUpdateTechnicalDocument, addTechnicalDocument, updateTechnicalDocument, deleteTechnicalDocument, documentAddInputCheck, documentEditInputCheck, uploadClick, selectFile, AdminNavigation, Alert, Loading }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})